(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  if (!customElements.get('palito-header-overlay')) {
    customElements.define('palito-header-overlay', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.section-header');
        this.wrapper = this.section?.querySelector('[data-palito-overlay]');
        if (!this.wrapper || this.wrapper.dataset.palitoOverlay !== 'true') return;
        this.updateHeight = () => {
          const height = this.wrapper.getBoundingClientRect().height;
          this.section.style.setProperty('--palito-header-height', `${height}px`);
        };
        this.updateScroll = () => this.section.classList.toggle('palito-scrolled', window.scrollY > 24);
        this.updateHeight();
        this.updateScroll();
        this.section.classList.add('palito-overlay');
        window.addEventListener('scroll', this.updateScroll, { passive: true });
        window.addEventListener('resize', this.updateHeight, { passive: true });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.updateHeight);
          this.resizeObserver.observe(this.wrapper);
        }
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.updateScroll);
        window.removeEventListener('resize', this.updateHeight);
        this.resizeObserver?.disconnect();
        this.section?.classList.remove('palito-overlay', 'palito-scrolled');
        this.section?.style.removeProperty('--palito-header-height');
      }
    });
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palito-rustic"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('palito-rustic')) {
  customElements.define('palito-rustic', class extends HTMLElement {
    connectedCallback() {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window) || window.Shopify?.designMode) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('pr-in');
            this.observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08 });
      this.querySelectorAll('.pr-reveal').forEach(el => {
        if (el.getBoundingClientRect().top > innerHeight) el.classList.add('pr-pending');
        this.observer.observe(el);
      });
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
